import React from "react";
import CenteredPageContentContainer from "../components/CenteredPageContentContainer";
import PaperContainer from "../components/PaperContainer";
import ForgotPasswordForm from "../components/forms/ForgotPasswordForm";
import { Typography } from "@material-ui/core";

const ForgotPasswordPage = () => (
  <CenteredPageContentContainer>
    <PaperContainer title="Wachtwoord vergeten">
      <Typography>
        Vul uw e-mailadres in en u krijgt een link toegestuurd waarmee u een
        nieuw wachtwoord aan kunt maken.
      </Typography>
      <ForgotPasswordForm />
    </PaperContainer>
  </CenteredPageContentContainer>
);

export default ForgotPasswordPage;



// WEBPACK FOOTER //
// ./src/pages/ForgotPasswordPage.js